<template>
    <div
        class="page-wrap"
        v-loading="loading"
        element-loading-text="Please wait. This might take a while depending on the size and amount of your attachments."
    >
        <div style="width: 100%">
            <el-row :gutter="15">
                <el-col>
                    <h2 v-if="currentStep < 6">Hello{{ currentUserName }}!</h2>
                    <h2 v-else>Thank you!</h2>
                </el-col>
            </el-row>
            <el-row :gutter="15">
                <el-col>
                    <FormStep
                        @nextStep="currentStep += 1"
                        @prevStep="currentStep -= 1"
                        v-model="formData[steps[0]]"
                        :step="currentStep"
                        v-if="currentStep == 0"
                        step-title="Contact details of the person applying"
                    ></FormStep>
                    <FormStep
                        @nextStep="currentStep += 1"
                        @prevStep="currentStep -= 1"
                        :step="currentStep"
                        v-model="formData[steps[1]]"
                        v-if="currentStep == 1"
                        :applicant="formData.applicant"
                        step-title="Contact details for Architect / Architecture office or Firm"
                    ></FormStep>
                    <FormStep
                        @nextStep="currentStep += 1"
                        @prevStep="currentStep -= 1"
                        :step="currentStep"
                        v-model="formData[steps[2]]"
                        v-if="currentStep == 2"
                        :applicant="formData.applicant"
                        step-title="Contact details for Client"
                    ></FormStep>
                    <FormStep
                        @nextStep="currentStep += 1"
                        @prevStep="currentStep -= 1"
                        :step="currentStep"
                        v-model="formData[steps[3]]"
                        v-if="currentStep == 3"
                        :applicant="formData.applicant"
                        step-title="Contact details for Contractor"
                    ></FormStep>
                    <FormStep
                        @nextStep="currentStep += 1"
                        @prevStep="currentStep -= 1"
                        :step="currentStep"
                        v-model="formData[steps[4]]"
                        v-if="currentStep == 4"
                        :applicant="formData.applicant"
                        step-title="Contact details for Associate Architect"
                    ></FormStep>
                    <FormStep
                        @nextStep="currentStep += 1"
                        @prevStep="currentStep -= 1"
                        :step="currentStep"
                        v-model="formData[steps[5]]"
                        v-if="currentStep == 5"
                        :applicant="formData.applicant"
                        step-title="Project Details"
                    ></FormStep>
                    <FormStep
                        @nextStep="currentStep += 1"
                        @prevStep="currentStep -= 1"
                        :step="currentStep"
                        v-model="formData[steps[6]]"
                        v-if="currentStep == 6"
                        :applicant="formData.applicant"
                        step-title="Billing Address"
                    ></FormStep>
                    <PaymentStep
                        :step="currentStep"
                        v-model="formData[steps[7]]"
                        v-if="currentStep == 7"
                        :billing="formData.billing"
                        @gosubmit="handleSubmitForm"
                    ></PaymentStep>
                    <ThankyouStep
                        :step="currentStep"
                        v-if="currentStep == 8"
                        :paymethod="formData.payment.method"
                        :form-id="submittedFormId"
                    ></ThankyouStep>
                </el-col>
            </el-row>
        </div>
    </div>
</template>

<script>
import FormStep from "./FormStep";
import PaymentStep from "./PaymentStep";
import ThankyouStep from "./ThankyouStep";
import formApi from "../api";
import Header from "@/core/components/Header";
import Footer from "@/core/components/Footer";

export default {
    components: {
        FormStep,
        PaymentStep,
        ThankyouStep,
        Header,
        Footer,
    },
    methods: {
        handleSubmitForm() {
            let self = this;
            if (self.submittedFormId) {
                self.processPayment();
            } else {
                this.loading = true;
                formApi
                    .save(this.formData, this.formType)
                    .then(function (response) {
                        if (response && response.data && response.data.id) {
                            self.submittedFormId = response.data.id;
                            self.processPayment();
                        } else {
                            alert(
                                "Unfortunately, we could not save the form. Please try again."
                            );
                        }
                    })
                    .catch(function (error) {
                        alert(
                            "Oops, it appears that something went wrong! Please try again!"
                        );
                    })
                    .then(() => {
                        this.loading = false;
                    });
            }
        },
        processPayment() {
            if (this.formData.payment.method == "bank") {
                this.currentStep += 1;
            } else {
                this.pay();
            }
        },
        pay() {
            let self = this;
            self.loading = true;
            self.paymentAttempt += 1;
            let callbacks = {
                onError: function (error) {
                    alert(
                        "Oops, our payment gateway could not process your card. Please try again, or choose another payment method."
                    );
                    self.loading = false;
                    formApi.savePaymentAttempt(
                        self.submittedFormId,
                        "error",
                        error
                    );
                },
                onDeclined: function (response) {
                    alert(
                        "Unfortunately, your card was not accepted. Please check with your issuer bank if there is any problem, try with another card, or try another payment method."
                    );
                    self.loading = false;
                    formApi.savePaymentAttempt(
                        self.submittedFormId,
                        "declined",
                        JSON.stringify(response)
                    );
                },
                onApproval: function (response) {
                    formApi
                        .savePaymentAttempt(
                            self.submittedFormId,
                            "approved",
                            JSON.stringify(response)
                        )
                        .then(function (response) {})
                        .catch(function (error) {})
                        .then(() => {
                            self.currentStep += 1;
                            self.loading = false;
                        });
                },
            };
            formApi
                .getPaymentToken(self.submittedFormId)
                .then(function (response) {
                    if (response && response.data && response.data.token) {
                        let paymentData = {
                            ssl_txn_auth_token: response.data.token,
                            ssl_card_number:
                                self.formData.payment.cardnumber.replace(
                                    /\D/g,
                                    ""
                                ),
                            ssl_exp_date:
                                self.formData.payment.cardmonth +
                                self.formData.payment.cardyear,
                            ssl_get_token: "Y",
                            ssl_add_token: "Y",
                            ssl_first_name: self.formData.billing.firstname,
                            ssl_last_name: self.formData.billing.lastname,
                            ssl_cvv2cvc2: self.formData.payment.cvv,
                            ssl_merchant_txn_id:
                                "LIDE#" +
                                self.submittedFormId +
                                "_" +
                                self.paymentAttempt,
                        };
                        self.loading = true;
                        window.ConvergeEmbeddedPayment.pay(
                            paymentData,
                            callbacks
                        );
                    } else {
                        self.loading = false;
                        if (response.data && response.data.message) {
                            alert(response.data.message);
                        } else {
                            alert(
                                "Unfortunately, we could not process the card payment. Please try again, or choose another payment method."
                            );
                        }
                    }
                })
                .catch(function (error) {
                    self.loading = false;
                    alert(
                        "Oops, it appears that something went wrong! Please try again, or choose another payment method."
                    );
                });
        },
    },
    data: () => ({
        loading: false,
        currentStep: 0,
        submittedFormId: "",
        paymentAttempt: 0,
        formType: "americanarchitecture",
        steps: [
            "applicant",
            "architect",
            "client",
            "contractor",
            "associate_architect",
            "project_details",
            "billing",
            "payment",
            "thankyou",
        ],
        title: window.config.appName,
        formData: {
            applicant: {
                gender: null,
                firstname: "",
                lastname: "",
                company_name: "",
                job_title: "",
                phone_number: "",
                fax: "",
                email: "",
                web_address: "",
                address1: "",
                address2: "",
                country: "",
                state_region: "",
                city: "",
                postcode: "",
                applying_as: null,
                newsletter: null,
            },
            architect: {
                gender: null,
                firstname: "",
                lastname: "",
                company_name: "",
                job_title: "",
                phone_number: "",
                fax: "",
                email: "",
                web_address: "",
                address1: "",
                address2: "",
                country: "",
                state_region: "",
                city: "",
                postcode: "",
                sameAsApplicant: false,
            },
            client: {
                gender: null,
                firstname: "",
                lastname: "",
                company_name: "",
                job_title: "",
                phone_number: "",
                fax: "",
                email: "",
                web_address: "",
                address1: "",
                address2: "",
                country: "",
                state_region: "",
                city: "",
                postcode: "",
                sameAsApplicant: false,
            },
            contractor: {
                gender: null,
                firstname: "",
                lastname: "",
                company_name: "",
                job_title: "",
                phone_number: "",
                fax: "",
                email: "",
                web_address: "",
                address1: "",
                address2: "",
                country: "",
                state_region: "",
                city: "",
                postcode: "",
                sameAsApplicant: false,
            },
            associate_architect: {
                gender: null,
                firstname: "",
                lastname: "",
                company_name: "",
                job_title: "",
                phone_number: "",
                fax: "",
                email: "",
                web_address: "",
                address1: "",
                address2: "",
                country: "",
                state_region: "",
                city: "",
                postcode: "",
                sameAsApplicant: false,
            },
            project_details: {
                category: "",
                project_title: "",
                year_of_production: "",
                state_country_of_production: "",
                architect_name: "",
                client: "",
                contractor: "",
                photographer: "",
                design_team: "",
                other: "",
                lead_architects: "",
                landscape_architects: "",
                video_link: "",
                images: [],
                floorplans: [],
                project_description: "",
            },
            billing: {
                gender: null,
                firstname: "",
                lastname: "",
                company_name: "",
                vat_id: "",
                phone_number: "",
                fax: "",
                email: "",
                web_address: "",
                address1: "",
                address2: "",
                country: "",
                state_region: "",
                city: "",
                postcode: "",
                sameAsApplicant: false,
            },
            payment: {
                method: "card",
                cardnumber: null,
                cardmonth: null,
                cardyear: null,
                cvv: null,
            },
        },
    }),
};
</script>
